export enum CookiesTab {
  DEFINITION = "definition",
  TYPES = "types",
  MANAGEMENT = "management",
}
